import { Account } from '@/client/accounts';
import { useFeatureFlag } from '@/hooks/useFeatureFlag';
import { isFreeTrial, PostHogFeatureFlags } from '@/utils/posthog';

export const useAwarenessHidden = (
  account: Account | null | undefined,
): boolean => {
  const { canUseFeature, accountCanUseFeature } = useFeatureFlag();

  return (
    !!account &&
    isFreeTrial(account) === 'yes' &&
    (canUseFeature(PostHogFeatureFlags.HIDE_AWARENESS_TRAINING) ||
      accountCanUseFeature(
        PostHogFeatureFlags.HIDE_AWARENESS_TRAINING,
        account.featureFlagAbility,
      ))
  );
};
